export default __webpack_public_path__ + "static/codemymobile_website_2_blue_white_-React-Native_section_02-bd38242f9f87c3b2e0fc90f54c139249.jpg";